
import { Component, Vue } from 'vue-property-decorator';

// Components
import VButton from '@/components/VButton/VButton.vue';

type titlesType = {
    document: string[];
    report: string[];
};

@Component({
    components: { VButton },
})
export default class PMReports extends Vue {
    types: (keyof titlesType)[] = ['document', 'report'];
    buttonTitles = {
        // report: ['dpcExec', 'construction', 'consolidated', 'deadlines'],
        document: ['bpc', 'dpcExec', 'dpcQuart', 'weeklyReport'],
        report: ['dpcExec'],
    };

    goToPage(type: string, title: string) {
        this.$router.push({
            name: `projectManagement.${type}.${title}`,
        });
    }
}
